import { Grid, Typography } from '@mui/material';

export default function BeaconDetails({ item }) {
  const versionA = item.version_a || item.a || {};
  const versionB = item.version_b || item.b || {};
  const rows = [
    ['Beacon ID', item.beacon_id],
    ['Event Name', item.event_name || versionA.event_name || versionB.event_name || 'N/A'],
    ['Ver A Found', versionA.found ? 'Yes' : 'No'],
    ['Ver A Valid', versionA.valid ? 'Yes' : 'No'],
    ['Ver B Found', versionB.found ? 'Yes' : 'No'],
    ['Ver B Valid', versionB.valid ? 'Yes' : 'No'],
  ];

  return (
    <Grid container spacing={1}>
      {rows.map(([label, value]) => (
        <Grid item xs={12} md={6} key={label}>
          <Typography variant="caption" color="text.secondary">
            {label}
          </Typography>
          <Typography variant="body2">{value}</Typography>
        </Grid>
      ))}
    </Grid>
  );
}
